module.exports = __webpack_public_path__ + "assets/floor-tower-section.png?c4743fdc9f023df4b58fb49c6bc19965";